import { UserCreateToSpatialLevelUseCase } from "@admin/domain/usecases/create-user-spatial-level.usecase";
import type { CreateUserModalFormValuesValidated } from "@admin/presentation/components/create-user-modal/create-user-modal-form.view.tsx";
import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository";
import type { Nullable } from "@core/domain/types/nullable.type";
import { LoadLayoutStore } from "@core/presentation/components/feedback/load-layout/load-layout.store";
import { BaseViewModel } from "@iot-platform/core";
import type { UserCreateToSpatialLevel, UserResume } from "@iot-platform/user";
import { inject, injectable } from "inversify";
import { action, makeObservable, observable, runInAction } from "mobx";

@injectable()
export class CreateUserModalViewModel extends BaseViewModel {
    @observable
    initialLoading = true;

    constructor(
        @inject(UserCreateToSpatialLevelUseCase)
        private readonly userCreateToSpatialLevelUseCase: UserCreateToSpatialLevelUseCase,
    ) {
        super();
        makeObservable(this);
    }

    override didMount(): void {
        this.initViewData();
    }

    @action
    initViewData(): void {
        runInAction(() => {
            this.initialLoading = false;
        });
    }

    @action
    async createUserToSpatialLevel(
        values: CreateUserModalFormValuesValidated,
    ): Promise<Nullable<UserResume>> {
        LoadLayoutStore.start();

        const userCreateToSpatialLevel: UserCreateToSpatialLevel = {
            username: values.username,
            email: values.email,
            spatialLevelIds: values.spatialLevelIds,
            fieldTech: values.fieldTech,
        };

        const userCreated = await this.userCreateToSpatialLevelUseCase.execute(
            userCreateToSpatialLevel,
        );

        if (userCreated) {
            ToastManagerRepository.success();
        }

        LoadLayoutStore.finish();

        return userCreated;
    }
}
